export const testIds = {
  PageStripRoot: 'PageStrip_Root',
};
